import React from "react";
import { Box, Stack, Container, Text, Image, HStack } from "@chakra-ui/react";
import social1 from "../../assets/images/opensea 1.svg";
import social2 from "../../assets/images/Vector (4).svg";
import social3 from "../../assets/images/Vector (5).svg";
import social4 from "../../assets/images/Vector (6).svg";
import social5 from "../../assets/images/Vector (7).svg";

import logo from "../../assets/images/log.png";

function index() {
  return (
    <Container maxW="container.xl" mb={20} w="100%">
      <Box w="100%">
        <Stack
          w="100%"
          direction={{ base: "column", md: "row" }}
          justifyContent="space-between"
          alignItems="center"
        >
          <Image src={logo} w={{ base: "50px", md: "80px" }} />
          <Text>2022 - Created By Marbleverse NFT team</Text>
          <HStack spacing={5}>
            <a href="https://t.me/+-U5XB4TeqNVjYjgy">
              <Image src={social3} w="30px" />
            </a>
            <a href="https://t.me/Dmitry_Forest">
              <Image src={social2} w="30px" />
            </a>
            <a href="https://discord.gg/K346qxBW">
              <Image src={social4} w="30px" />
            </a>
            <a href="https://www.instagram.com/marbleverse_nft/">
              <Image src={social5} w="30px" />
            </a>
            <a href="https://opensea.io/MarbleverseNFT">
              <Image src={social1} w="30px" />
            </a>
          </HStack>
        </Stack>
      </Box>
    </Container>
  );
}

export default index;
